import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id 4B18056D-33ED-4AD5-888D-AF90713CBC73
 * name vector-square-close
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vector-square-close.svg
 * tags
 * - Vector 
 */
export const VectorSquareCloseIcon = createSvgIcon(<><path d="M4 4H6V6H4V4M6 20H4V18H6V20M18 8V16H16V18H8V16H6V8H8V2H2V8H4V16H2V22H8V20H16V22H22V16H20V8H22V2H16V8H18M20 20H18V18H20V20M18 6V4H20V6H18M14 6H10V4H14V6Z" /></>, 'VectorSquareCloseIcon');
export default VectorSquareCloseIcon